import React, { useState } from 'react';
import { CircularProgress, Grid, IconButton, Paper, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export default function ViewFacility({ form, facilityLocationName, selectedFile }) {
    const { client_id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state;
    const [imageLoaded, setImageLoaded] = useState(false);

    const properties = [
        { label: 'Facility Name:', value: form?.facilityName || '--' },
        { label: 'Short Name:', value: form?.facilityShortName || '--' },
        { label: 'Address:', value: form?.address || '--' },
        { label: 'Map URL:', value: form?.map_url || '--' },
        { label: 'Location:', value: facilityLocationName || '--' },
        { label: 'Segment:', value: form?.segment || '--' },
    ];

    const facilityDetails = (
        <Paper 
                sx={{
                    wordWrap: 'break-word',
                    padding: {
                    xs: 0,
                    sm: 2, 
                    md: 2  
                    }
                }}
                >
            {properties.map((property, index) => (
                <div key={index}>
                    <Grid container item className='w3-padding'>
                        <Grid item xs={12} sm={6} md={6}>
                            <Typography sx={{ fontWeight: 'bold' }}>{property.label}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            {property.value}
                        </Grid>
                    </Grid>
                </div>
            ))}
        </Paper>
    )

    const facilityImages = (
        <Grid container item md={12} spacing={2} sx={{ marginTop: 2 }}>
            <Grid item xs={12}>
                <Typography
                    sx={{ fontWeight: 'bold', paddingLeft: '8px', fontSize: '16px' }}
                >
                    Uploaded Images
                </Typography>
            </Grid>
            {selectedFile && selectedFile.map((mediaItem, idx) => {
                if (!mediaItem?.fileUrls || mediaItem.fileUrls.length === 0) {
                    return null;
                }
                const url = new URL(
                    mediaItem.fileUrls.length === 1
                        ? mediaItem?.fileUrls[0]
                        : mediaItem?.fileUrls
                );
                const srcUrl = url.href;

                return (
                    <Grid item xs={12} sm={6} md={4} key={idx} style={{ position: 'relative' }}>
                        {!imageLoaded && (
                            <CircularProgress
                                size={40}
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                }}
                            />
                        )}
                        <img
                            style={{ padding: '5px'}}
                            width="100%"
                            height="auto"
                            src={srcUrl}
                            alt={`uploadedImage-${idx}`}
                            onLoad={() => setImageLoaded(true)}
                        />
                    </Grid>
                );
            })}
        </Grid>
    );

    return (
        <Grid 
            container 
            sx={{
                padding: {
                xs: '12px 8px', 
                sm: '12px 8px', 
                md: '12px 24px' 
                }
            }}
        >
            <Grid container item xs={12}>
                <Grid item xs={5} justifyContent='flex-start'>
                    <IconButton
                        onClick={() => locationState?.status ? navigate(-1) : navigate(`/client/${client_id}/settings/facilities`)}
                        color="inherit">
                        <ArrowBackIosIcon fontSize='small'/>
                    </IconButton>
                </Grid>
                <Grid item xs={7} justifyContent='flex-start'>
                    <h5 style={{ fontWeight: 'bold' }}>FACILITY DETAILS</h5>
                </Grid>
            </Grid>
            <Grid item xs={12}>
               {facilityDetails}
            </Grid>
            {selectedFile?.length > 0 && (<Grid item xs={12}>
                {facilityImages}
            </Grid>)}
        </Grid>
    )
}